import { isDebankUrl, omitQueryToUrl } from '@/utils';

export const omitRefCode = (url: string) => {
  if (!isDebankUrl(url)) return url;

  if (/\/claim\b/?.test(url)) {
    return url;
  }
  return omitQueryToUrl(url, 'r');
};
